// tailwind-colors.ts
import tailwindConfig from './tailwind.config'
import resolveConfig from 'tailwindcss/resolveConfig'

// Resolve the Tailwind configuration
const fullConfig = resolveConfig(tailwindConfig)

// Extract the colors
export const tailwindColors = fullConfig.theme.colors

type ExtractColors<T> = T extends string
  ? T
  : T extends object
    ? { [K in keyof T]: ExtractColors<T[K]> }[keyof T]
    : never

// Define the type that extracts color values
export type TailwindColor = ExtractColors<typeof tailwindColors>
export type TailwindColorValue = keyof typeof tailwindColors
export type TailwindColorOrString = TailwindColor | (string & {})
